/** This must match expectations in the logging API in order to be viewed in Kibana */
export interface ILogData {
  message?: string;
  level?: ELogLevel;
  error?: string;
  BookingIdentifier?: string;
}

export enum ELogLevel {
  debug = 'debug',
  info = 'info',
  warn = 'warn',
  error = 'error',
  fatal = 'fatal',
  local = 'local'
}
